import {
    SET_PRIVILEGES,
    SET_EDIT_PRIVILEGE,
    SET_NEW_PRIVILEGE,
    SET_DELETE_PRIVILEGE,
    SET_DELETE_MULTI_PRIVILEGE,
    SET_LIST_PRIVILEGES,
    SET_PRIVILEGE,
    RESET_ITEMS_PRIVILEGE,
    RESET_LIST_PRIVILEGES,
} from "redux/constants/Privileges";

const initalAgreementState = {
    items: [],
    list: [],
    selected: {},
    loading: true,
};
const Privileges = (state = initalAgreementState, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_PRIVILEGES: {
            return { ...state, items: payload, loading: false };
        }
        case SET_LIST_PRIVILEGES: {
            return { ...state, list: payload };
        }
        case SET_PRIVILEGE: {
            return { ...state, selected: payload };
        }
        case SET_NEW_PRIVILEGE: {
            return { ...state, items: [payload, ...state.items] };
        }

        case SET_EDIT_PRIVILEGE: {
            let list = [...state.items];

            try {
                let ind = list.findIndex((item) => item._id === payload._id);

                if (ind > -1) {
                    list[ind] = payload;
                }
            } catch (error) {}

            return { ...state, items: list };
        }

        case SET_DELETE_PRIVILEGE: {
            let list = state.items.filter((item) => item._id !== payload);

            return { ...state, items: list };
        }

        case SET_DELETE_MULTI_PRIVILEGE: {
            let arr = payload.split(",");
            let list = state.items.filter((item) => !arr.includes(item._id));

            return { ...state, items: list };
        }
        case RESET_LIST_PRIVILEGES: {
            return { ...state, list: [] };
        }

        case RESET_ITEMS_PRIVILEGE: {
            return { ...state, items: [], loading: true };
        }

        default:
            return state;
    }
};

export default Privileges;
